<div class="stats-section">
    <div class="stats-container">
        <div class="stat-item">
            <h2 class="stat-number">30+</h2>
            <p class="stat-label">Años de experiencia</p>
        </div>

        <div class="stat-item">
            <h2 class="stat-number">1000+</h2>
            <p class="stat-label">Viviendas construidas</p>
        </div>

        <div class="stat-item">
            <h2 class="stat-number">30+</h2>
            <p class="stat-label">Desarrollos inmobiliarios</p>
        </div>

        <div class="stat-item">
            <h2 class="stat-number">350,000+</h2>
            <p class="stat-label">m construidos</p>
        </div>
    </div>
</div>